const styles = theme => ({
  highlightedKeyword: {
    backgroundColor: theme.palette.highlightingColors.lightBlue,
    padding: 5,
  },
});

export default styles;
